import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import icons from 'src/icons';
import {
    selectAlertMessageModalReason,
    setAlertMessageModalReason,
} from 'src/shared/slices/app-slice';

import { Button } from '@alfalab/core-components/button';
import { Modal } from '@alfalab/core-components/modal';

import { InstructionBody } from './elems/instruction-body';
import { SystemMessageItem } from './elems/system-message-item';

export const AlertMessageModal = () => {
    const dispatch = useDispatch();
    const alertMessageReason = useSelector(selectAlertMessageModalReason);

    const [showInstruction, setShowInstruction] = useState(false);

    const handleClose = () => {
        if (!showInstruction) {
            dispatch(setAlertMessageModalReason(''));
        }
        setShowInstruction(false);
    };

    return (
        <Modal open={alertMessageReason.length > 0} onClose={handleClose}>
            <Modal.Header
                sticky={true}
                hasCloser={true}
                title={showInstruction ? 'Как разблокировать учётную запись' : ''}
            />
            <Modal.Content flex={true}>
                {showInstruction ? (
                    <InstructionBody />
                ) : (
                    <React.Fragment>
                        {alertMessageReason === 'no_phone_number' && (
                            <SystemMessageItem
                                title='Добавьте номер телефона, чтобы войти без VPN Банка'
                                subTitle='Это можно сделать в сервисе <strong>Личные данные</strong> Alfa People с включенным VPN Альфа-Банка'
                                icon={icons.AccountIcon}
                            >
                                <Button size='s' view='primary' onClick={handleClose}>
                                    Понятно
                                </Button>
                            </SystemMessageItem>
                        )}

                        {alertMessageReason === 'password_expired' && (
                            <SystemMessageItem
                                title='Пароль больше не действует'
                                subTitle='Измените его в мобильном приложении или обратитесь в Help Desk. Пароль нужно менять каждые 90 дней'
                                icon={icons.LockIcon}
                            >
                                <Button size='s' view='primary' onClick={handleClose}>
                                    Понятно
                                </Button>
                            </SystemMessageItem>
                        )}

                        {alertMessageReason === 'user_blocked' && (
                            <SystemMessageItem
                                title='Учётная запись заблокирована'
                                subTitle='Вы использовали все попытки ввода пароля'
                                icon={icons.ForbiddenIcon}
                            >
                                <Button
                                    size='s'
                                    view='primary'
                                    onClick={() => {
                                        setShowInstruction(true);
                                    }}
                                >
                                    Как разблокировать?
                                </Button>
                            </SystemMessageItem>
                        )}
                    </React.Fragment>
                )}
            </Modal.Content>
        </Modal>
    );
};
